export const navItems = [
  { name: "Home", href: "/" },
  { name: "Discover Us", href: "/discover-us" },
  { name: "Industries", href: "/industries" },
  { name: "Services", href: "/services" },
  { name: "Careers", href: "/careers" },
  { name: "Contact", href: "/contact" },
];

export const heroData = {
  title: "Lamaqi ",
  subtitle: "A growing IT Consulting and Talent Solutions partner",
  description: "",
  ctaButton: "Get Started",
};

export const businessTransformations = {
  title: "OUR VISION",
  subtitle: "Business Transformations",
  description:
    "To be at the forefront of business transformations – with core principles that never go out of style",
  points: [
    "Transforming talent strategies",
    "Finding talent that reflects new channels",
    "Hand in hand: Culture and talent",
  ],
};

export const featuredOn = {
  title: "Trusted By",
  companies: [
    { name: "Fortune 500", logo: "/api/placeholder/120/60" },
    { name: "Small Businesses", logo: "/api/placeholder/120/60" },
    { name: "Mid-size Companies", logo: "/api/placeholder/120/60" },
    { name: "Various Industries", logo: "/api/placeholder/120/60" },
  ],
};

export const valuablePartner = {
  title: "OUR COMMITMENT",
  subtitle: "Your Valuable Partner",
  description:
    "We strive to be our customers most valuable partner, an industry-recognized thought leader, and an involved member of the communities we serve.",
  cta: "Learn More",
};

export const whatWeDo = {
  title: "What We Do",
  services: [
    {
      title: "Global Talent Procurement",
      description:
        "We assist in procuring the best talent across INDIA, UK, EU, ME & US for small, mid-size, and Fortune 500 companies across various industries.",
    },
    {
      title: "High-Performing Teams",
      description:
        "With a deep talent network and industry experience, we build high-performing teams that deliver results - on time and with precision.",
    },
    {
      title: "Recruitment Specialization",
      description:
        "We specialize in recruitment across all levels and industries, finding and retaining top-tier IT professionals.",
    },
    {
      title: "Inclusive Partnerships",
      description:
        "We bring growth, equality, and inclusion into our vendor and supplier ecosystem by expanding opportunities and partnering with small and medium businesses.",
    },
  ],
};

export const ourCommitment = {
  title: "OUR COMMITMENT",
  subtitle: "Delivering Exceptional Value",
  description:
    "We are committed to delivering value through accelerated time-to-productivity, flexible and effective resource allocation, higher retention rates, consistency of skills and process, more efficient knowledge transfer, and the ability to focus on results rather than staff management.",
  cta: "Partner With Us",
  stats: [
    { number: "50+", label: "DELIGHTED CUSTOMERS" },
    { number: "500+", label: "SUCCESSFUL PLACEMENTS" },
    { number: "95%", label: "CLIENT RETENTION" },
    { number: "24/7", label: "DEDICATED SUPPORT" },
  ],
};

export const footerData = {
  address: "New Delhi 110092, India",
  email: "info@lamaqi.com",
  copyright: "Copyright © 2025 Lamaqi",
  poweredBy: "HR Analytics & Consulting",
  support: [
    "Career Guidance",
    "Client Support",
    "Partner Program",
    "Community",
  ],
  company: ["About Us", "Careers", "Industries", "Services"],
};
